import { render, staticRenderFns } from "./OtherReceiptListFunc.vue?vue&type=template&id=50fb0e04&scoped=true&"
import script from "./OtherReceiptListFunc.vue?vue&type=script&lang=js&"
export * from "./OtherReceiptListFunc.vue?vue&type=script&lang=js&"
import style0 from "./OtherReceiptListFunc.vue?vue&type=style&index=0&id=50fb0e04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fb0e04",
  null
  
)

export default component.exports